import React from 'react';
import { Markup } from 'interweave';
import { useStravaTranslations } from '@strava/container-context';
import clsx from '@strava/ui/clsx/clsx';

import styles from './DisclaimerText.module.scss';

type DisclaimerTextProps = {
  className?: string;
};

const DisclaimerText = ({ className }: DisclaimerTextProps) => {
  const { t } = useStravaTranslations();

  const legalTerms = t(
    'authentication_ui.disclaimer_text.by_clicking_cta_html',
    { terms_path: '/legal/terms' }
  );

  const legalPrivacy = t(
    'authentication_ui.disclaimer_text.view_privacy_policy_html',
    { privacy_path: '/legal/privacy' }
  );

  return (
    <p className={clsx(styles.disclaimerText, className)}>
      <Markup noWrap={true} content={legalTerms} />{' '}
      <Markup noWrap={true} content={legalPrivacy} />
    </p>
  );
};

export default DisclaimerText;
